var mainMenu = document.querySelectorAll('.navmenu-meganav.navmenu-meganav--desktop .navmenu-depth-3');
Array.from(mainMenu).map((menu) => {
    var mainHeight = menu.offsetWidth;
      if (mainHeight > 250) {
        $(menu).parent().addClass('break_menu');
      }               
  })
  

// peter custom

class ProductPage{
  constructor() {
    this.init();
  }

  productDesc = () => {
//     $('body').delegate( '.product-description-toggle','click',function(e){
//       if($(this).html() === 'READ MORE'){
//         $(this).html('READ LESS');
//         e.stopPropagation();
//         $('.product-shortcode-open').show(200);
//         $('.product-shortcode').hide(200);
//       }else{
//           $(this).html('READ MORE');
//           $('.product-shortcode-open').hide(200);
//           $('.product-shortcode').show(200);
//       }
//     });
    
      $('.product-description-togglemore').click(function(){
        $('.product-description-readless').show(200);
        $('.product-description-readmore').hide(200);
      });
      $('.product-description-toggleless').click(function(){
        $('.product-description-readless').hide(200);
        $('.product-description-readmore').show(200);
      });
    
  }

  productFaqs = () => {
   $('.accordion-title').click(function(){
    $(this).toggleClass('active');
    $(this).siblings().slideToggle(300);
   });
  }

  init = () => {
    this.productDesc();
    this.productFaqs();
  }
}

class CollectionPage {
  constructor(){
    this.init();
  }

//   productVeriant = () => {
//     setTimeout(() => {
//       $('.cust-product--options .form-field-input li:not(.sold-out-variant)').click(function(){
//         $(this).addClass('active');
//         $(this).siblings().removeClass('active');
//       });
//     }, 2000);;
//   }

  paginationJs = () => {
    $('.pagination--inner .pagination--ellipsis').prev().first('li').hide(0).prev().hide(0);
    $('.pagination--inner li.pagination--active').next().show();
  }



  init = () => {
    //this.productVeriant();
    this.paginationJs();
  }

}

class homepage {
  constructor() {
    this.init();
  }

  homepageSlider = ($sliderInit) => {
    $($sliderInit).slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      dots:false,
      arrows:false,
      autoplay: true,
      autoplaySpeed: 2000,
      speed: 1000,
      responsive:[
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 720,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots:true
          }
        }
      ]
    });
  }

  accordion = ($trigger, $target ) => {
    $($trigger).click(function(){
      $(this).parent().toggleClass('active');
      $(this).siblings($target).slideToggle(250);
    });
  }
  
  headerMegaMenu = () => {
      $('.navmenu-meganav.navmenu-meganav--desktop .navmenu-depth-3').each(function(){
          if($(this).children().length > 7){
            $(this).css({
                "display": "block",
                "column-count": "2"
            });
          }
      });
  }

//   fixedFooterEffect = () => {
//     $(document).ready(function(){
//       var footerID = $('#shopify-section-static-footer').height();
//       $('#shopify-section-static-footer').css({
//         'position':'fixed',
//         'bottom':'0',
//         'width':'100%'
//       });
//       $('body').css('padding-bottom',footerID+'px');
//     });

//   }

  init = () => {
    this.homepageSlider('.cust-testi-wrapper');
    this.headerMegaMenu();
    this.accordion('.faq_que','.faq_ans');
  }

}

new homepage;
new ProductPage;
new CollectionPage;



 $(document).ready(function(){
        $('.navmenu-link-active').closest('.panel').css("display","block");
        $('.navmenu-link-active').closest('.panel').siblings('.CollectionCustomAccordion').addClass("active");    
      });
      
      $(document).on('click', '.CollectionCustomAccordion', function(event) {
          $(this).toggleClass('active');
          $(this).siblings().slideToggle(250);
      });
  
     $(document).on('click', '.cust-product--options .form-field-input li:not(.sold-out-variant)', function(event) {
            $(this).addClass('active');
			$(this).siblings().removeClass('active');
        
 		  var custompriceget = $(this).attr("data-price"),
              productId = $(this).attr("data-product-id");
          $('#'+productId).text(custompriceget);
      });
      
      function collectionFilterReload() {
          setTimeout(function () {
            $('.navmenu-link-active').closest('.panel').css("display","block");
        	$('.navmenu-link-active').closest('.panel').siblings('.CollectionCustomAccordion').addClass("active");
          }, 3000);
      }
